import { styled } from '@mui/material';

const NotificationItemWrapper = styled('div')`
  width: 100%;
  padding: 20px 25px 0;

  ${({ theme }) => theme.breakpoints.between('md', 'lg')} {
    padding: 20px 35px 25px 25px;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 392px;
  }
`;

export default NotificationItemWrapper;
